/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ExternalCountriesOfOperation =
  typeof ExternalCountriesOfOperation[keyof typeof ExternalCountriesOfOperation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalCountriesOfOperation = {
  UK: 'UK',
  GLOBAL: 'GLOBAL',
} as const;
